/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductBenefitModel } from '../../models/product-benefit-model';

export interface ProductBenefitGetAllProductBenefitsGet$Params {
}

export function productBenefitGetAllProductBenefitsGet(http: HttpClient, rootUrl: string, params?: ProductBenefitGetAllProductBenefitsGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<ProductBenefitModel>>> {
  const rb = new RequestBuilder(rootUrl, productBenefitGetAllProductBenefitsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<ProductBenefitModel>>;
    })
  );
}

productBenefitGetAllProductBenefitsGet.PATH = '/ProductBenefit/GetAllProductBenefits';
